import { PROCESS_FIELD_ERROR, VERIFY_FORM_VALIDITY } from "./form-errors-action-types";

const processFieldError = (fieldName, validity) => ({
    type: PROCESS_FIELD_ERROR,
    fieldName,
    validity
});

const verifyFormValidity = (validity) => ({
    type: VERIFY_FORM_VALIDITY,
    validity
});

export default {
    processFieldError,
    verifyFormValidity
};
